export async function encodeFileToBase64(file, metadata = {}) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64 = reader.result.split(',')[1];

      resolve({
        file: base64,
        metadata: {
          filename: file.name,
          'content_type': file.type,
          ...metadata,
        },
      });
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
